<template>
  <vs-button
    size="small"
    type="border"
    :href="refSanitize"
    :disabled="disabled"
    :rel="rel"
    :target="target">
    <slot></slot>
  </vs-button>
</template>

<script>
export default {
  name: "aSecure",
  computed: {
    refSanitize() {
      return this.$sanitizeUrl(this.href)
    },
    vclass() {
      return this.class;
    }
  },
  props: [
    'href',
    'disabled',
    'target',
    'rel'
  ]
}
</script>
